/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonRef,
  PersonRefOptional,
  PersonRefMetaI,
  PersonRefTrackedI,
} from "./person-ref";
import { PersonRefTracked, PersonRefMeta } from "./person-ref";

/**
 *
 * @export
 * @interface WithOptionalPersonRef
 */
export interface WithOptionalPersonRefOptional {
  /**
   *
   * @type {PersonRef}
   * @memberof WithOptionalPersonRef
   */
  personId?: PersonRefOptional;
}

export interface WithOptionalPersonRef extends WithOptionalPersonRefOptional {
  /**
   *
   * @type {PersonRef}
   * @memberof WithOptionalPersonRef
   */
  personId?: PersonRef;
}

export interface WithOptionalPersonRefTrackedI {
  /**
   *
   * @type {PersonRef}
   * @memberof WithOptionalPersonRef
   */
  personId?: PersonRefTrackedI;
  personIdIsSet: boolean;
}

transformDatesMap.set(
  "WithOptionalPersonRef",
  function (model: WithOptionalPersonRef) {
    const transformDatespersonId = transformDatesMap.get("PersonRef");
    if (transformDatespersonId && model.personId) {
      transformDatespersonId(model.personId);
    }
  },
);

export type WithOptionalPersonRefMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  personId: PropertyMeta<PersonRefMetaI>;
}>;

export var WithOptionalPersonRefMeta: WithOptionalPersonRefMetaI =
  {} as WithOptionalPersonRefMetaI;
WithOptionalPersonRefMeta = typeMeta("WithOptionalPersonRef", {
  personId: propertyMeta("personId", false, false, false, PersonRefMeta),
});

const metaI = WithOptionalPersonRefMeta;

registerMeta(() => {});

export class WithOptionalPersonRefTracked implements WithOptionalPersonRefTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  personId__I?: PersonRefTracked = undefined;
  personIdIsSet: boolean = false;
  set personId(v: undefined | PersonRefTracked) {
    if (v !== undefined) {
      this.personId__I = v;
      this.personIdIsSet = true;
    } else {
      this.personId__I = v || undefined;
      this.personIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get personId() {
    return this.personId__I;
  }
  constructor(config?: WithOptionalPersonRefOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {
    this.personId?.setIds();
  }
  assignFrom(
    config: WithOptionalPersonRefOptional,
    options?: AssignOptions,
  ): WithOptionalPersonRefTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.personId && this.personIdApplyFilter(optionsRequired.filter)) {
      this.personId = new PersonRefTracked(config.personId, options);
      if (optionsRequired.unassign) this.personIdIsSet = false;
      else this.personIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): WithOptionalPersonRefTrackedI {
    const cloned = {} as WithOptionalPersonRefTrackedI;
    if (
      this.personIdIsSetDeep() &&
      this.personIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.personIdIsSet = true;
      cloned.personId = this.personId?.removeUnset(filter);
    } else {
      //cloned.personIdIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): WithOptionalPersonRefTrackedI {
    if (!this.personIdApplyFilter(filter)) this.personIdIsSet = false;
    this.personId?.unassignAll(filter);

    return this;
  }
  personIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      WithOptionalPersonRefMeta.personId,
      WithOptionalPersonRefMeta,
      this.personId,
      this,
    );
  }
  personIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.personIdIsSet && this.personIdApplyFilter(filter)) return true;
    return this.personId?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.personIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
